import { Result } from './model';
export var asMapped = function (sanitizer, mapFn) { return function (value, path) {
    var result = sanitizer(value, path);
    if (Result.isOk(result)) {
        return Result.ok(mapFn(result.ok));
    }
    return result;
}; };
